module.exports = __webpack_public_path__ + "static/img/icon-not-started.2ca792b7.svg";